import Roulette from "../engine/components/Roulette";
import EventDispatcher from "../engine/EventDispatcher";
import TarotCard from "./TarotCard";

export class TarotTable {
  private container: HTMLElement;

  constructor() {
    this.container = document.getElementById("tarot-table");
  }

  deal(card: Record<number, TarotCard>): void {
    const cardRoulette = new Roulette(22);
    
    for (let i = 0; i < 22; i++) {
      cardRoulette.add(card[i], i);
    }

    EventDispatcher.on("card:activated", () => {
      cardRoulette.disable();
    });

    EventDispatcher.on("card:deactivated", () => {
      cardRoulette.enable();
    });
    
    cardRoulette.appendTo(this.container);
  }
}
